import React, { useEffect, useState } from "react";
import { BottomNavigation as Navigation } from "@mui/material";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import { Grid } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";

import { style } from "./style";

import GetImages from "@/components/GetImages";

import { IRoleType } from "@/models/role";
import { ISessionKeys } from "@/models";

import { storage } from "@/utils/Storage";
import { bottomNavigation } from "@/utils/common";

import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { setSelectedChat } from "@/store/slices/chat";
import {
  setCurrentActivBottomNavItem,
  universalSearchFilterDetails,
} from "@/store/slices/doctor/universalSearchFilter";

interface INavItemInfo {
  path: string;
  icon: string;
  selectedIcon: string;
  label: string;
}
const MobileBottomNavigation: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const intl = useIntl();

  const [navIndex, setNavIndex] = useState<number>(
    location.state?.navItem ?? 0
  );
  const [navItems, setNavItems] = useState<INavItemInfo[]>();

  const dispatch = useAppDispatch();
  const { currentActivBottomNavItem } = useAppSelector(
    universalSearchFilterDetails
  );

  const roleType = storage.getSessionToken(ISessionKeys.ROLE_TYPE);
  const hasRolesType =
    roleType === IRoleType.GUEST ||
    roleType === IRoleType.PATIENT ||
    roleType === IRoleType.DOCTOR ||
    roleType === IRoleType.JR_DOCTOR ||
    roleType === IRoleType.PHARMACY;

  const handleNavigationChange = (
    event: React.SyntheticEvent,
    newValue: number
  ) => {
    const newPath = navItems[newValue]?.path;

    if (newPath) {
      if (newPath === "/chats") {
        dispatch(setSelectedChat(null));
      }
      setNavIndex(newValue);
      navigate(newPath);
    }
  };

  const setNavigationItemsByRoleType = () => {
    if (!roleType) {
      setNavItems(bottomNavigation[IRoleType.PATIENT]);
      return;
    }
    if (hasRolesType) {
      setNavItems(bottomNavigation[roleType]);
    }
  };

  useEffect(() => {
    if (navItems?.length > 0) {
      const currentPathIndex = navItems.findIndex(
        (item) => item.path === location.pathname
      );

      if (currentPathIndex !== -1) {
        const activeNav =
          currentActivBottomNavItem !== currentPathIndex
            ? currentPathIndex
            : currentActivBottomNavItem;

        setNavIndex(activeNav);
        dispatch(setCurrentActivBottomNavItem(activeNav));
      }
    }
  }, [location.pathname, navItems, dispatch, currentActivBottomNavItem]);

  useEffect(() => {
    if (location?.state?.navItem) {
      setNavIndex(location?.state?.navItem);
    }
  }, [location.state]);

  useEffect(() => {
    setNavigationItemsByRoleType();
  }, []);

  return (
    <Grid item sx={style.navigationContainer}>
      <Navigation
        showLabels
        sx={style.navigation}
        value={navIndex}
        onChange={handleNavigationChange}
      >
        {navItems
          ? navItems.map((nav, index) => (
              <BottomNavigationAction
                label={intl.formatMessage({
                  id: nav.label,
                  defaultMessage: "Bottom Navigation Action",
                })}
                icon={
                  navIndex === index ? (
                    <GetImages
                      fill="var(--orange-500)"
                      name={nav.selectedIcon}
                      width="22"
                      height="22"
                    />
                  ) : (
                    <GetImages
                      fill="var(--gray-400)"
                      name={nav.icon}
                      width="22"
                      height="22"
                    />
                  )
                }
                key={index}
                sx={
                  navIndex === index
                    ? style.navigationSelectedText
                    : style.navigationText
                }
              />
            ))
          : null}
      </Navigation>
    </Grid>
  );
};

export default MobileBottomNavigation;
